import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import bgImage from "../Assets/bgMethodology.png";
import Header from "../Header/Header";
const countryData = [
  { "Origin Country": "Germany", "Destination Country": "Poland" },
  { "Origin Country": "Germany", "Destination Country": "France" },
  { "Origin Country": "Austria", "Destination Country": "Germany" },
  { "Origin Country": "Austria", "Destination Country": "Poland" },
  { "Origin Country": "Belgium", "Destination Country": "Germany" },
  { "Origin Country": "Belgium", "Destination Country": "Poland" },
  { "Origin Country": "Bulgaria", "Destination Country": "Germany" },
  { "Origin Country": "Czech Republic", "Destination Country": "Poland" },
  { "Origin Country": "Denmark", "Destination Country": "Germany" },
  { "Origin Country": "France", "Destination Country": "Germany" },
  { "Origin Country": "France", "Destination Country": "Poland" },
  { "Origin Country": "Greece", "Destination Country": "Germany" },
  { "Origin Country": "Greece", "Destination Country": "Poland" },
  { "Origin Country": "Hungary", "Destination Country": "France" },
  { "Origin Country": "Hungary", "Destination Country": "Germany" },
  { "Origin Country": "Hungary", "Destination Country": "Poland" },
  { "Origin Country": "Italy", "Destination Country": "France" },
  { "Origin Country": "Italy", "Destination Country": "Germany" },
  { "Origin Country": "Italy", "Destination Country": "Poland" },
  { "Origin Country": "Netherlands", "Destination Country": "Germany" },
  { "Origin Country": "Netherlands", "Destination Country": "Poland" },
  { "Origin Country": "Poland", "Destination Country": "France" },
  { "Origin Country": "Poland", "Destination Country": "Germany" },
  { "Origin Country": "Slovakia", "Destination Country": "France" },
  { "Origin Country": "Slovakia", "Destination Country": "Germany" },
  { "Origin Country": "Slovakia", "Destination Country": "Poland" },
  { "Origin Country": "Slovenia", "Destination Country": "Poland" },
  { "Origin Country": "Spain", "Destination Country": "Poland" },
  { "Origin Country": "Switzerland", "Destination Country": "Germany" },
  { "Origin Country": "Switzerland", "Destination Country": "Poland" },
  { "Origin Country": "Belarus", "Destination Country": "Poland" },
  { "Origin Country": "Luxembourg", "Destination Country": "France" },
  { "Origin Country": "Luxembourg", "Destination Country": "Germany" },
  { "Origin Country": "Luxembourg", "Destination Country": "Poland" },
  { "Origin Country": "Serbia", "Destination Country": "Germany" },
  { "Origin Country": "Serbia", "Destination Country": "Poland" },
  { "Origin Country": "Serbia", "Destination Country": "France" },
  {
    "Origin Country": "Bosnia and Herzegovina",
    "Destination Country": "Poland",
  },
  {
    "Origin Country": "Bosnia and Herzegovina",
    "Destination Country": "Germany",
  },
  { "Origin Country": "Czech Republic", "Destination Country": "Germany" },
  { "Origin Country": "Spain", "Destination Country": "France" },
  { "Origin Country": "Belgium", "Destination Country": "France" },
  { "Origin Country": "Netherlands", "Destination Country": "France" },
  { "Origin Country": "Switzerland", "Destination Country": "France" },
  { "Origin Country": "Denmark", "Destination Country": "France" },
  { "Origin Country": "Romania", "Destination Country": "France" },
  { "Origin Country": "Austria", "Destination Country": "France" },
  { "Origin Country": "Croatia", "Destination Country": "France" },
  { "Origin Country": "Greece", "Destination Country": "France" },
  { "Origin Country": "Sweden", "Destination Country": "France" },
  { "Origin Country": "Czech Republic", "Destination Country": "France" },
  { "Origin Country": "Estonia", "Destination Country": "France" },
  { "Origin Country": "Portugal", "Destination Country": "France" },
  { "Origin Country": "Finland", "Destination Country": "France" },
  {
    "Origin Country": "Bosnia and Herzegovina",
    "Destination Country": "France",
  },
  { "Origin Country": "Ukraine", "Destination Country": "France" },
  { "Origin Country": "Bulgaria", "Destination Country": "France" },
  { "Origin Country": "Lithuania", "Destination Country": "France" },
  { "Origin Country": "Spain", "Destination Country": "Germany" },
  { "Origin Country": "Croatia", "Destination Country": "Germany" },
  { "Origin Country": "Sweden", "Destination Country": "Germany" },
  { "Origin Country": "Lithuania", "Destination Country": "Germany" },
  { "Origin Country": "Romania", "Destination Country": "Germany" },
  { "Origin Country": "Finland", "Destination Country": "Germany" },
  { "Origin Country": "Ukraine", "Destination Country": "Germany" },
  { "Origin Country": "Estonia", "Destination Country": "Germany" },
  { "Origin Country": "Slovenia", "Destination Country": "Germany" },
  { "Origin Country": "Romania", "Destination Country": "Poland" },
  { "Origin Country": "Portugal", "Destination Country": "Poland" },
  { "Origin Country": "Sweden", "Destination Country": "Poland" },
  { "Origin Country": "Finland", "Destination Country": "Poland" },
  { "Origin Country": "Ukraine", "Destination Country": "Poland" },
  { "Origin Country": "Latvia", "Destination Country": "Poland" },
  { "Origin Country": "Lithuania", "Destination Country": "Poland" },
  { "Origin Country": "Bulgaria", "Destination Country": "Poland" },
  { "Origin Country": "Denmark", "Destination Country": "Poland" },
  { "Origin Country": "Estonia", "Destination Country": "Poland" },
  { "Origin Country": "France", "Destination Country": "Belgium" },
  { "Origin Country": "Germany", "Destination Country": "Belgium" },
  { "Origin Country": "Netherlands", "Destination Country": "Belgium" },
  { "Origin Country": "Spain", "Destination Country": "Belgium" },
  { "Origin Country": "France", "Destination Country": "Italy" },
  { "Origin Country": "Germany", "Destination Country": "Italy" },
  { "Origin Country": "Spain", "Destination Country": "Italy" },
  { "Origin Country": "Belgium", "Destination Country": "Italy" },
  { "Origin Country": "Belgium", "Destination Country": "Netherlands" },
  { "Origin Country": "Germany", "Destination Country": "Netherlands" },
  { "Origin Country": "Greece", "Destination Country": "Netherlands" },
  { "Origin Country": "Italy", "Destination Country": "Netherlands" },
  { "Origin Country": "Greece", "Destination Country": "Italy" },
  { "Origin Country": "Netherlands", "Destination Country": "Italy" },
  { "Origin Country": "Luxembourg", "Destination Country": "Belgium" },
  { "Origin Country": "Switzerland", "Destination Country": "Italy" },
  { "Origin Country": "Austria", "Destination Country": "Italy" },
  { "Origin Country": "Poland", "Destination Country": "Netherlands" },
  { "Origin Country": "Luxembourg", "Destination Country": "Netherlands" },
  { "Origin Country": "Poland", "Destination Country": "Belgium" },
  { "Origin Country": "Poland", "Destination Country": "Italy" },
  { "Origin Country": "Spain", "Destination Country": "Netherlands" },
  { "Origin Country": "France", "Destination Country": "Netherlands" },
  { "Origin Country": "Denmark", "Destination Country": "Italy" },
  { "Origin Country": "Hungary", "Destination Country": "Italy" },
  { "Origin Country": "Austria", "Destination Country": "Belgium" },
  { "Origin Country": "Slovenia", "Destination Country": "Belgium" },
  { "Origin Country": "Italy", "Destination Country": "Belgium" },
  { "Origin Country": "Romania", "Destination Country": "Italy" },
  { "Origin Country": "Estonia", "Destination Country": "Italy" },
  { "Origin Country": "Denmark", "Destination Country": "Netherlands" },
  { "Origin Country": "Switzerland", "Destination Country": "Belgium" },
  { "Origin Country": "Denmark", "Destination Country": "Belgium" },
  { "Origin Country": "Switzerland", "Destination Country": "Netherlands" },
  { "Origin Country": "Estonia", "Destination Country": "Belgium" },
  { "Origin Country": "Portugal", "Destination Country": "Italy" },
  { "Origin Country": "Serbia", "Destination Country": "Italy" },
  { "Origin Country": "Czech Republic", "Destination Country": "Belgium" },
  { "Origin Country": "Bulgaria", "Destination Country": "Italy" },
  { "Origin Country": "Finland", "Destination Country": "Netherlands" },
];

const LandLockedCountryData = [
  "Belarus",
  "Luxembourg",
  "Serbia",
  "Uganda",
  "Uzbekistan",
  "Chad",
  "Kazakhstan",
  "Armenia",
  "Laos",
  "Ethiopia",
  "Tajikistan",
  "Moldova",
  "Eswatini",
  "Bhutan",
  "Kyrgyzstan",
  "Mongolia",
  "Paraguay",
  "Bolivia",
  "Malawi",
  "Zambia",
  "Turkmenistan",
  "Mali",
  "Zimbabwe",
  "Burundi",
  "Burkina Faso",
  "Nepal",
  "Rwanda",
  "Afghanistan",
  "North Macedonia",
  "Central African Republic",
];

export default function MethodologyAssumptionsPage() {
  const navigation = useNavigate();

  const steps = [
    {
      id: 1,
      title: "Data Discovery & Integration",
      desc: "We unify and clean supply chain data using automated tools.",
    },
    {
      id: 2,
      title: "Data Discovery & Integration",
      desc: "We unify and clean supply chain data using automated tools.",
    },
    {
      id: 3,
      title: "Data Discovery & Integration",
      desc: "We unify and clean supply chain data using automated tools.",
    },
    {
      id: 4,
      title: "Data Discovery & Integration",
      desc: "We unify and clean supply chain data using automated tools.",
    },
    {
      id: 5,
      title: "Data Discovery & Integration",
      desc: "We unify and clean supply chain data using automated tools.",
    },
  ];

  const positions = [
    { top: "5%", left: "50%", transform: "translate(-50%, 0)" },
    { top: "45%", right: "-60%", transform: "translate(0, -50%)" }, //2nd
    { bottom: "10%", right: "-37%", transform: "translate(0, 0)" }, //3rd
    { bottom: "10%", left: "-40%", transform: "translate(0, 0)" }, //4th
    { top: "45%", left: "-60%", transform: "translate(0, -50%)" }, //5th
  ];
  const formattedDataLanLocked = LandLockedCountryData.map((country) => ({
    Country: country,
  }));

  const handleDownloadExcel = (data, sheetName, sheetNameUpdate) => {
    const timestamp = new Date().toISOString().replace(/[:.-]/g, "_");
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, `${sheetNameUpdate}${timestamp}.xlsx`);
  };

  const assumptions = [
    "Category classification was performed basis a combination of HS codes and material description.",
    "Trade routes were determined based on requested country combinations. Alternate sourcing locations were added by identifying major manufacturing hubs at material & destination level.",
    "All UL plant locations provided were treated as destination cities, while manufacturing hubs located near selected ports were considered as origin cities.",
    "For each origin and destination country, three sea ports were selected.",
    "Materials with missing origin countries were excluded from the current scope.",
    "All applicable duties and additional charges were determined based on the relevant HS codes and origin destination country combinations.",
    "Import duties for USA, Canada, and South Africa are calculated on an FOB (Free on Board) basis.",
    "For all other countries, duties were applied based on CIF (Cost, Insurance, and Freight) value.",
    // Removed "Intra-European trade.." from here
    "All port related charges and ocean freight have been considered for a standard 20ft Dry FCL Container.",
    // `"Landlocked Trade: Port charges and sea freight were considered as zero for landlocked countries, as trade movement is by land."${(
    //   <Box
    //     component="span"
    //     // onClick={handleDownloadExcel}
    //     sx={{
    //       ml: 1,
    //       color: "primary.main",
    //       fontWeight: "bold",
    //       textDecoration: "underline",
    //       cursor: "pointer",
    //       display: "inline",
    //     }}
    //   >
    //     Download Excel
    //   </Box>
    // )}`,
    <span>
      {/* <strong
        style={{
          color: "#1976d2",
          cursor: "pointer",
          textDecoration: "underline",
          fontWeight: 600,
        }}
        onClick={() => {
          handleDownloadExcel(
            formattedDataLanLocked,
            "Landlocked Countries",
            "Landlocked Countries"
          );
        }}
      ></strong> */}
      Landlocked Trade : Port charges and sea freight were considered as zero
      for landlocked countries, as trade movement is by land.{" "}
      <strong
        style={{
          color: "#1976d2",
          cursor: "pointer",
          textDecoration: "underline",
          fontWeight: 600,
        }}
        onClick={() => {
          handleDownloadExcel(
            formattedDataLanLocked,
            "Landlocked Countries",
            "Landlocked Countries"
          );
        }}
      >
       Download excel
      </strong>
    </span>,
    "Domestic Trade: For domestic trade, only local logistics costs and applicable duties/VAT are considered.",
    // "Intra-Europe Trade: For trade between European countries where movements are primarily by road, sea freight and port charges were excluded, and only local logistics costs were considered.",
  ];

  const methodologySteps = [
    "Material specific category classification & HS Code mapping.",
    "Identification of trade lanes basis manufacturing hubs & major ports for respective plant locations to reflect accurate trade flow.",
    "Comprehensive port charges and sea freight are regularly updated from port authority websites, freight forwarders & our internal database",
    "Tariffs & Duties are sourced from government websites & subscribed international databases.",
    "Market insights is provided using our regularly tracked data on tariffs, fuels & sea freight.",
  ];

  // const positions = [
  //   { top: "25%", left: "50%" },
  //   { top: "50%", left: "85%" },
  //   { top: "90%", left: "65%" },
  //   { top: "90%", left: "30%" },
  //   { top: "50%", left: "15%" },
  // ];

  const midpoint = Math.ceil(assumptions.length / 2);
  const leftAssumptions = assumptions.slice(0, midpoint + 1);
  const rightAssumptions = assumptions.slice(midpoint + 1);

  return (
    <>
      <Header />
      {/* <Box
        sx={{
          // backgroundImage:`${bgImage}`,
          // background: "linear-gradient(to bottom, #000000, #2d0b52)",\
          marginTop: "67px",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          justifyContent: "center",
          color: "#fff",
          position: "relative",
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Our Methodology
        </Typography>

        <Box
          sx={{
            position: "relative",
            width: "500px",
            height: "500px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.1) 20%, transparent 80%)",
          }}
        >
          {methodologySteps.map((step, index) => {
            const number = index + 1; // display number (1,2,3,4...)
            return (
              <Box
                key={step.id || number}
                sx={{
                  position: "absolute",
                  width: "340px",
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  borderRadius: "8px",
                  padding: "10px",
                  textAlign: "left",
                  ...positions[index],
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
              
                  <Box
                    component="span"
                    sx={{
                      fontSize: "50px",
                      fontWeight: "bold",
                      color: "#a97ff4",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    {number <= 3 && number}
                  </Box>

                  <Box>
                  
                    <Typography variant="body2" color="#ccc">
                      {step}
                    </Typography>
                  </Box>

                  <Box
                    component="span"
                    sx={{
                      fontSize: "50px",
                      fontWeight: "bold",
                      color: "#a97ff4",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {number > 3 && number}
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box> */}
      <div>
        {/* Methodology Section */}
        <Box
          sx={{
            width: "100%",
            mt: 4,
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            justifyContent: "center",
            color: "#fff",
            position: "relative",
            marginTop: "67px",
            display: "block",
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            gutterBottom
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
            }}
          >
            Our Methodology
          </Typography>
          {/* Desktop / Tablet Circle Layout */}
          <Box
            sx={{
              display: { xs: "none", lg: "flex" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "500px",
                height: "500px",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(255,255,255,0.1) 20%, transparent 80%)",
              }}
            >
              {methodologySteps.map((step, index) => {
                const number = index + 1;
                return (
                  <Box
                    key={index}
                    sx={{
                      position: "absolute",
                      width: "340px",
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.2)",
                      borderRadius: "8px",
                      p: 2,
                      textAlign: "left",
                      ...positions[index],
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="span"
                        sx={{
                          fontSize: "50px",
                          fontWeight: "bold",
                          color: "#a97ff4",
                          mr: 1,
                        }}
                      >
                        {number <= 3 && number}
                      </Box>
                      <Typography variant="body2" sx={{ color: "#ccc" }}>
                        {step}
                      </Typography>
                      <Box
                        component="span"
                        sx={{
                          fontSize: "50px",
                          fontWeight: "bold",
                          color: "#a97ff4",
                          ml: "auto",
                        }}
                      >
                        {number > 3 && number}
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
          {/* Desktop Circle Layout (Large screens only) */}
          <Box
            sx={{
              display: { xs: "none", lg: "flex" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* your circular layout stays the same */}
          </Box>

          {/* Mobile + Tablet Layout */}
          <Box
            sx={{
              display: { xs: "flex", lg: "none" },
              flexDirection: "column",
              gap: 2,
              px: 2,
              mt: 2,
            }}
          >
            {methodologySteps.map((step, index) => (
              <Paper
                key={index}
                elevation={2}
                sx={{
                  p: 2,
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "#ccc",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: "#a97ff4",
                    }}
                  >
                    {index + 1}.
                  </Typography>
                  <Typography variant="body2">{step}</Typography>
                </Box>
              </Paper>
            ))}
          </Box>

          {/* Mobile Single Column Layout */}
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              flexDirection: "column",
              gap: 2,
              px: 2,
              mt: 2,
            }}
          >
            {methodologySteps.map((step, index) => (
              <Paper
                key={index}
                elevation={2}
                sx={{
                  p: 2,
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "#ccc",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: "#a97ff4",
                    }}
                  >
                    {index + 1}.
                  </Typography>
                  <Typography variant="body2">{step}</Typography>
                </Box>
              </Paper>
            ))}
          </Box>
        </Box>

        {/* Assumptions Section */}
        <Box sx={{ py: 2, textAlign: "left", marginBottom: "50px" }}>
          <Container maxWidth="lg" sx={{ height: "100%" }}>
            <Typography
              variant="h4"
              sx={{
                color: "#5000b8",
                fontWeight: 550,
                fontFamily: '"Lora", serif',
              }}
              gutterBottom
            >
              Our Assumptions
            </Typography>
            <Grid container spacing={2}>
              {[leftAssumptions, rightAssumptions].map((half, colIndex) => (
                <Grid item xs={12} md={6} key={colIndex}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      paddingBottom: 0,
                      textAlign: "left",
                      height: "100%",
                      // overflow: "scroll",
                      display: "flex",
                      flexDirection: "column",
                      background: "#f7f8fc",
                      borderRadius: "8px",
                      background: "var(--grey-1, #F7F8FC)",
                      /* s4 */
                      boxShadow: "0 32px 64px -12px rgba(16, 24, 40, 0.14)",
                    }}
                  >
                    <List>
                      {half.map((text, index) => (
                        <ListItem key={index}>
                          <ListItemIcon>
                            <StarIcon sx={{ color: "#7847dc" }} />
                          </ListItemIcon>
                          <ListItemText primary={text} />
                        </ListItem>
                      ))}

                      {colIndex === 1 && (
                        <ListItem>
                          <ListItemIcon sx={{}}>
                            {/* <StarIcon color="primary" /> */}
                            <StarIcon sx={{ color: "#7847dc" }} />
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <>
                                Intra-Europe Trade: For trade between European
                                countries where movements are primarily by road,
                                sea freight and port charges were excluded, and
                                only local logistics costs were considered.
                                <Box
                                  component="span"
                                  onClick={() =>
                                    handleDownloadExcel(
                                      countryData,
                                      "Intra Europe Combinations",
                                      "Intra Europe Combinations"
                                    )
                                  }
                                  sx={{
                                    ml: 1,
                                    color: "primary.main",
                                    fontWeight: "bold",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    display: "inline",
                                  }}
                                >
                                  Download Excel
                                </Box>
                              </>
                            }
                          />
                          {/* <input
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleExcelUpload}
                          /> */}
                        </ListItem>
                      )}
                    </List>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </div>
    </>
  );
}
